<div id="page" class="page">
    <!-- ***site header html start*** -->
    <header id="masthead" class="site-header">
        <!-- header html start -->
        <div class="top-header">
           <div class="container">
              <div class="top-header-inner">
                 <div class="header-contact text-left">
                    <a href="tel:+01977259912">
                       <i aria-hidden="true" class="icon icon-phone-call2"></i>
                       <div class="header-contact-details">
                          <span class="contact-label">Para contacto vía telefónico :</span>
                          <h5 class="header-contact-no">+(506) 8868 4846</h5>
                       </div>
                    </a>
                 </div>
                 <div class="site-logo text-center">
                    <p class="site-title">
                      <!--  <a href="index.html">
                          <img src="assets/images/site-logo.png" alt="Logo">
                       </a> -->
                    </p>
                 </div>
                 <div class="header-icon text-right">
                   <!--  <div class="header-search-icon d-inline-block">
                       <a href="javascript: void(0)" [matMenuTriggerFor]="shopping">
                          <i aria-hidden="true" class="fas fa-shopping-cart"></i>
                       </a>
                    </div> -->
                 </div>
              </div>
           </div>
        </div>


        <mat-menu #social="matMenu">
           <button mat-menu-item><span class="myrow"><i class="fab fa-facebook-f" aria-hidden="true"></i>VoyJaleas</span></button>
           <button mat-menu-item><span class="myrow"><i class="fab fa-instagram" aria-hidden="true"></i>@voyjaleas</span></button>
           <button mat-menu-item><span class="myrow"><i class="fab fa-youtube" aria-hidden="true"></i>VoyJaleas</span></button>
           <button mat-menu-item><span class="myrow"><i class="fab fa-whatsapp" aria-hidden="true"></i>(+34) 602 52 31 56</span></button>
        </mat-menu>

        <div class="bottom-header">
           <div class="container">
              <div class="bottom-header-inner d-flex justify-content-between align-items-center">
                 <div class="header-social social-icon">
                    <ul>
                       <li>
                          <a href="javascript: void(0)" [matMenuTriggerFor]="social">
                             <i class="fab fa-facebook-f" aria-hidden="true"></i>
                          </a>
                       </li>
                       <li>
                          <a href="javascript: void(0)"[matMenuTriggerFor]="social">
                             <i class="fab fa-instagram" aria-hidden="true"></i>
                          </a>
                       </li>
                       <li>
                          <a href="javascript: void(0)" [matMenuTriggerFor]="social">
                             <i class="fab fa-youtube" aria-hidden="true"></i>
                          </a>
                       </li>
                       <li>
                          <a href="javascript: void(0)" [matMenuTriggerFor]="social">
                             <i class="fab fa-whatsapp" aria-hidden="true"></i>
                          </a>
                       </li>
                    </ul>
                 </div>
                 <div class="navigation-container d-none d-lg-block">
                    <nav id="navigation" class="navigation">
                       <ul>
                          <li class="menu-item-has-children">
                             <a href="about.html">Nosotros</a>
                             <ul>
                                <li>
                                   <a href="javascript: void(0)">Sebastián Jiménez</a>
                                </li>

                                <li>
                                   <a href="javascript: void(0)">Felipe Hidalgo</a>
                                </li>
                             </ul>
                          </li>
                          <li class="menu-item-has-children">
                             <a href="index.html">Para vos</a>
                             <ul>
                                <li>
                                   <a href="javascript: void(0)">Cotización</a>
                                </li>
                                <li>
                                   <a href="javascript: void(0)">Oferta de paquetes</a>
                                </li>
                                <li>
                                   <a href="javascript: void(0)">Otros servicios</a>
                                </li>
             
                             </ul>
                          </li>
                          
                          <li>
                             <a href="javascript: void(0)">Contactar</a>
                          </li>
                       </ul>
                    </nav>
                 </div>
                 <div class="header-btn">
                    <a href="javascript: void(0)" class="round-btn">Cotización</a>
                 </div>
              </div>
           </div>
        </div>
        <div class="mobile-menu-container"></div>
     </header>

    <main id="content" class="site-main">
    <section class="booking-inner-page">
        <!-- ***Inner Banner html start form here*** -->
        <div class="inner-banner-wrap">
            <div class="inner-baner-container" style="background-image: url(assets/images/img7.jpg);">
                <div class="container">
                <div class="inner-banner-content">
                    <h1 class="page-title">Booking</h1>
                </div>
                </div>
            </div>
        </div>
        <!-- ***Inner Banner html end here*** -->
        <div class="booking-section">
            <div class="container">
                <div class="row">
                <div class="col-lg-8 right-sidebar">
                    <!-- step one form html start -->
                    <div class="booking-form-wrap">
                        <form method="get">

                            <div class="booking-content" *ngIf="false">
                                <div class="form-title">
                                    <span>1</span>
                                    <h3>Información personal</h3>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Nombre*</label>
                                            <input type="text" class="form-control" name="firstname_booking" [value]="getBookingField('name')">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Apellido*</label>
                                            <input type="text" class="form-control" name="lastname_booking" [value]="getBookingField('lastname')">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Email*</label>
                                            <input type="email" class="form-control" name="email_booking" [(ngModel)]="currentBooking.clientDetails.email">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Confirmar Email*</label>
                                            <input type="email" class="form-control" name="email_booking">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Teléfono*</label>
                                            <input type="text" class="form-control" name="lastname_booking">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- INFORMACIÓN DE PAGO BÁSICA -->
                            <div class="booking-content">
                                <div class="form-title">
                                    <span>1</span>
                                    <h3>Detalles del pago.</h3>
                                </div>
                                <div class="info-content">
                                    <div class="form-policy">
                                        <h3>Pago vía transferencia</h3>
                                        <label>Sebastián Antonio Jiménez Benavides</label>
                                        <p></p>
                                        <h5> BAC IBAN</h5>
                                        <p>CR29010200009135518006</p>
                                      
                                        </div>
                                </div>
                                <div class="info-content">
                                    <div class="form-policy">
                                        <h3>Paypal</h3>
                                        <p>sebasjb3@gmail.com</p>
                                        </div>
                                </div>
                                <div class="info-content">
                                    <div class="form-policy">
                                        <p>Una vez recibido el pago, te
                                            enviaremos toda la información
                                            relativa a tu proceso y te
                                            brindaremos acceso a tu carpeta
                                            de Google Drive con los checklists
                                            de control y seguimiento, entre
                                            otros.</p>
                                        </div>
                                </div>

                                
                            </div>

                            <!-- TERMIMNOS Y CONDICIONES -->
                            <div class="booking-content">
                                <div class="form-title">
                                    <span>2</span>
                                    <h3>Acuerdo de términos y condiciones.</h3>
                                </div>
                                <div class="info-content">
                                    <div class="form-policy">
                                        <h3>Términos y condiciones</h3>
                                        <mat-accordion>
                                            <mat-expansion-panel hideToggle>
                                              <mat-expansion-panel-header>
                                                <mat-panel-title>
                                                  Términos y condiciones generales
                                                </mat-panel-title>
                                                <mat-panel-description>
                                                  
                                                </mat-panel-description>
                                              </mat-expansion-panel-header>
                                              <p>
                                                La Propuesta económica es válida hasta el 20 de Mayo 2024.
                                                Los precios indicados son en dólares americanos.
                                                VOY JALEAS sólo estará obligado con el Cliente por las
                                                especificaciones que se hayan incorporado en esta Propuesta
                                                Comercial.
                                                De ninguna manera la contratación y pago de nuestros servicios de
                                                consultoría está sujeta al resultado del procedimiento de visado, ya
                                                que éste no depende de nosotros, ni de la persona que contrata los
                                                servicios.
                                                Se aplican nuestros términos y condiciones. Al firmar esta propuesta
                                                comercial, acepta nuestros Términos y condiciones disponibles en el
                                                contrato de Servicios que será enviado al cliente una vez aceptada la
                                                propuesta.
                                              </p>
                                            </mat-expansion-panel>
                                            <mat-expansion-panel hideToggle>
                                                <mat-expansion-panel-header>
                                                  <mat-panel-title>
                                                    Búsqueda de apartamento
                                                  </mat-panel-title>
                                                  <mat-panel-description>
                                                    
                                                  </mat-panel-description>
                                                </mat-expansion-panel-header>
                                                <p>
                                                    Reserva/Alquiler del apartamento: de ninguna manera la contratación y pago
                                                    de nuestros servicios de consultoría garantiza el resultado del procedimiento de
                                                    buscar y contratar un apartamento en la ciudad de Barcelona, ya que éste no
                                                    depende únicamente de VOY JALEAS, ni de la persona que contrata los servicios.
                                                    Tipos de apartamentos: Voy Jaleas solo ofrece el servicio de búsqueda de
                                                    apartamentos via agencia inmobiliaria, y de no de personas físicas.
                                                </p>
                                              </mat-expansion-panel>
                                        </mat-accordion>
                                        <!-- <div class="form-group" style="margin: 1rem auto;">
                                            <label class="checkbox-list">
                                                <input type="checkbox" name="s">
                                                <span class="custom-checkbox"></span>
                                                Acepto los términos y condiciones.
                                            </label>
                                        </div>
                                        <button type="submit" class="round-btn">Aceptar</button> -->
                                        </div>
                                </div>
                            </div>

                            <!-- PAYPAL BUTTONS - MODAL -->
                            <div class="booking-content" *ngIf="false">
                                <div class="form-title">
                                    <span>3</span>
                                    <h3>Detalles del pago</h3>
                                </div>
                                <div class="info-content">
                                    <h4>Ahora puedes pagar con Paypal o tarjeta de crédito/debito</h4>
                                    <p>Lorem ipsum dolor sit amet, vim id accusata sensibus, id ridens quaeque qui. Ne qui vocent ornatus molestie, reque fierent dissentiunt mel ea.</p>
                                    <a href="#">
                                        <img src="assets/images/paypal_bt.png" alt="">
                                    </a>
                                    <!-- <app-paypal-buttons></app-paypal-buttons> -->
                                </div>
                            </div>

                            <!-- BILLING ADDRESS -->
                            <div class="booking-content" *ngIf="false">
                            <div class="form-title">
                                <span>3</span>
                                <h3>Billing Address</h3>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Country*</label>
                                        <select name="country" id="country">
                                        <option value="" selected="">Select your country</option>
                                        <option value="Europe">Europe</option>
                                        <option value="United states">United states</option>
                                        <option value="Asia">Asia</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Street line 1*</label>
                                        <input type="text" name="street_1">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Street line 2</label>
                                        <input type="text" name="street_2">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group">
                                        <label>City*</label>
                                        <input type="text" name="city_booking">
                                    </div>
                                </div>
                                <div class="col-md-3 col-sm-6">
                                    <div class="form-group">
                                        <label>State*</label>
                                        <input type="text" name="state_booking">
                                    </div>
                                </div>
                                <div class="col-md-3 col-sm-6">
                                    <div class="form-group">
                                        <label>Postal code*</label>
                                        <input type="text" name="postal_code">
                                    </div>
                                </div>
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group">
                                        <label>Additional Information</label>
                                        <textarea rows="6" placeholder="Notes about your order, e.g. special notes for delivery"></textarea>
                                    </div>
                                </div>
                            </div>
                            <!--End row -->
                            </div>

                        </form>
                    </div>
                    <!-- step one form html end -->
                </div>
                <div class="col-lg-4">
                    <div class="price-table-summary">
                        <h4 class="bg-title">Resumen del pedido</h4>
                        <table>
                            <tbody>
                            <tr *ngFor="let item of currentBooking.products">
                                <td>
                                    <strong *ngIf="item.name">{{item.name}}</strong>
                                    <strong *ngIf="item.product">{{item.product}}</strong>
                                </td>
                                <td class="text-right">
                                    ${{item.price}}
                                </td>
                            </tr>
                            <!-- <tr>
                                <td>
                                    <strong>IVA</strong>
                                </td>
                                <td class="text-right">
                                    13%
                                </td>
                            </tr> -->
                            </tbody>
                        </table>
                        <table>
                            <tbody>
                            <!-- <tr class="total">
                                <td>
                                    <strong>Sub-Total</strong>
                                </td>
                                <td class="text-right">
                                    <strong>${{subtotal}}</strong>
                                </td>
                            </tr> -->
                            <tr class="total">
                                <td>
                                    <strong>Total</strong>
                                </td>
                                <td class="text-right">
                                    <strong>${{total}}</strong>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="widget-bg widget-support-wrap">
                        <div class="icon">
                            <i class="fas fa-phone-volume"></i>
                        </div>
                        <div class="support-content">
                            <h5>CONTACTO PARA ASISTENCIA</h5>
                            <a href="telto:12345678" class="phone">+(34) 602 523156</a>
                            <small>Lunes a Viernes 9.00am - 6.30pm</small>
                        </div>
                    </div>
                </div>
                </div>
            </div>
    </div>
    </section>
    </main>
    <!-- ***site footer html start form here*** -->
    <footer id="colophon" class="site-footer footer-primary">
    
    <div class="bottom-footer">
        <div class="container">
            <div class="copy-right text-center">Copyright &copy; 2024 VoyJaleas. All rights reserved.</div>
        </div>
    </div>
    </footer>
    <!-- ***site footer html end*** -->
    <a id="backTotop" href="#" class="to-top-icon">
    <i class="fas fa-chevron-up"></i>
    </a>
    <!-- ***custom search field html*** -->

    <!-- ***custom top bar offcanvas html*** -->
</div>

<!-- JavaScript -->
<!--       <script src="assets/vendors/jquery/jquery.js"></script>
<script src="assets/vendors/waypoint/waypoints.js"></script>
<script src="assets/vendors/bootstrap/js/bootstrap.min.js"></script>
<script src="assets/vendors/jquery-ui/jquery-ui.min.js"></script>
<script src="assets/vendors/countdown-date-loop-counter/loopcounter.js"></script>
<script src="assets/vendors/counterup/jquery.counterup.min.js"></script>
<script src="https://unpkg.com/imagesloaded@4/imagesloaded.pkgd.min.js"></script>
<script src="assets/vendors/masonry/masonry.pkgd.min.js"></script>
<script src="assets/vendors/slick/slick.min.js"></script>
<script src="assets/vendors/fancybox/dist/jquery.fancybox.min.js"></script>
<script src="assets/vendors/slick-nav/jquery.slicknav.js"></script>
<script src="assets/js/custom.min.js"></script> -->
